import { CRUISE_DATES_FILTER, PROMO_KEY } from 'components/CruiseSearchWidget/constants';
import { CalendarType } from 'components/CruiseSearchWidget/types';
import { isPromoCustomFilter, isUniqueFilter } from 'components/CruiseSearchWidget/utils/reducers';
import { SelectedOption, Selection } from 'components/FiltersProvider/types';
import { ADULTS, CHILDREN, DEFAULT_INITIAL_ADULTS, DEFAULT_INITIAL_CHILDREN } from 'components/NumberOfGuests/constants';
import { CUSTOM_FILTERS_KEY } from 'lib/apiClient';
import { UpdateSelectionItem } from 'lib/mappers';

function removeDatesSelectionByCalendar(currentSelection: Selection, historicalSelection: Array<SelectedOption>, calendarToRemove: CalendarType) {
	const dateRangesToRemove = historicalSelection.filter((item) => item.calendarType === calendarToRemove);
	const newSelection = {
		...currentSelection,
		[CRUISE_DATES_FILTER.key]: currentSelection[CRUISE_DATES_FILTER.key].filter(
			(dateRange) => !dateRangesToRemove.some((item) => item.option.dateRanges?.includes(dateRange)),
		),
	};
	return newSelection;
}

export function updateFiltersSelection(
	filterKey: string,
	selectedValue: UpdateSelectionItem,
	currentSelection: Selection,
	historicalSelection: Array<SelectedOption>,
): Selection {
	let newSelection = { ...currentSelection };
	const isExternalFilter = historicalSelection.find((item) => selectedValue.value.includes(item.option.code))?.isExternal;

	if (isExternalFilter) {
		return {
			...newSelection,
			[filterKey]: newSelection[filterKey]?.filter((item) => !selectedValue.value.includes(item)),
		};
	}

	if (selectedValue.calendarType === CalendarType.Dates) {
		newSelection = removeDatesSelectionByCalendar(currentSelection, historicalSelection, CalendarType.Months);

		const [dateRange] = selectedValue.value;
		const dateRangeExist = currentSelection[CRUISE_DATES_FILTER.key].find((value) => value === dateRange);

		newSelection[CRUISE_DATES_FILTER.key] = dateRangeExist ? [] : [dateRange];
		return newSelection;
	}

	if (selectedValue.calendarType === CalendarType.Months) {
		newSelection = removeDatesSelectionByCalendar(currentSelection, historicalSelection, CalendarType.Dates);
	}

	if (filterKey === ADULTS || filterKey === CHILDREN) {
		const currentAdults = currentSelection[ADULTS][0];
		const currentChildren = currentSelection[CHILDREN][0];

		return {
			...newSelection,
			...(!currentAdults && { [ADULTS]: [DEFAULT_INITIAL_ADULTS.toString()] }),
			...(!currentChildren && { [CHILDREN]: [DEFAULT_INITIAL_CHILDREN.toString()] }),
			[filterKey]: [...selectedValue.value],
		};
	}

	if (isUniqueFilter(selectedValue)) {
		const [value] = selectedValue.value;

		if (!currentSelection[filterKey].find((item) => item === value)) {
			Object.keys(currentSelection).forEach((filter) => (newSelection[filter] = []));
			newSelection = {
				...newSelection,
				...(selectedValue.criteria?.adults && { [ADULTS]: [selectedValue.criteria.adults.toString()] }),
				...(selectedValue.criteria?.children && { [CHILDREN]: [selectedValue.criteria.children.toString()] }),
				[filterKey]: [...selectedValue.value],
			};

			if (isPromoCustomFilter(selectedValue)) {
				newSelection = {
					...newSelection,
					[PROMO_KEY]: selectedValue.criteria?.promo as string[],
				};
			}
		} else {
			newSelection = {
				...newSelection,
				[CUSTOM_FILTERS_KEY]: [],
				[PROMO_KEY]: [],
			};
		}

		return newSelection;
	}

	selectedValue.value.forEach((value) => {
		if (!currentSelection[filterKey].find((item: string) => item === value)) {
			newSelection = {
				...newSelection,
				[filterKey]: [...newSelection[filterKey], value],
			};
		} else {
			newSelection = {
				...newSelection,
				[filterKey]: newSelection[filterKey].filter((item: string) => item !== value),
			};
		}

		newSelection = { ...newSelection };
	});

	return newSelection;
}
